module.exports = __webpack_public_path__ + "static/media/no-headers.c3b430f7.svg";